import { useState, useEffect, useCallback } from 'react';
import { ChecklistItem } from '@frontend/Models/Checklist';
import ChecklistService from '../../../../../../AppSettings/services/ChecklistService';

export interface UseDCDataReturn {
  checklistItems: ChecklistItem[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
  addChecklistItem: (item: ChecklistItem) => void;
}

export const useDCData = (matterId: string | undefined): UseDCDataReturn => {
  const [checklistItems, setChecklistItems] = useState<ChecklistItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async (): Promise<void> => {
    if (!matterId) return;

    setLoading(true);
    setError(null);

    try {
      const checklistResponse =
        await ChecklistService.getChecklistItemsByMatterId(matterId);

      setChecklistItems(checklistResponse);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch data');
    } finally {
      setLoading(false);
    }
  }, [matterId]);

  const addChecklistItem = useCallback((item: ChecklistItem) => {
    setChecklistItems(prev => [item, ...prev]);
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    checklistItems,
    loading,
    error,
    refetch: fetchData,
    addChecklistItem,
  };
};
